export const REST_API_KEY = ''; //커밋주의
export const REDIRECT_URI = '';